import React from "react";
import Grid from "@mui/material/Grid2";
import FuzzySearch from './FuzzySearch'
import EliminationSearch from "./EliminationSearch";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import useDebugInformation from "../../../../../../../../hooks/useDebugInformation";
import NumberedHeader from "../../../../../../../Shared/NumberedHeader";
import { useAppSelector } from "@store/hooks";

const name = "JobSearch"

type Props = {
    parent: string
    inputRef: any;
}

const JobSearch: React.FC<Props> = ({ parent, inputRef }) => {
    const debugName = `${parent}▷[${name}]`
    const problemComboJobValid = useAppSelector(({ state }) => state.ProblemComboJobValid)

    useDebugInformation(debugName, { parent })
    return (
        (<Paper elevation={4} sx={(theme) => ({
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
            padding: theme.spacing(2),
            [theme.breakpoints.up(600 + Number(theme.spacing(3)) * 2)]: {
                marginTop: theme.spacing(1),
                marginBottom: theme.spacing(2),
                padding: theme.spacing(2),
            },
            '& input': { height: "1em" }
        })}>
            <Grid container spacing={1}>
                <NumberedHeader description="SEARCH FOR JOB" number="1" variant={problemComboJobValid ? "green" : "red"} />
                <FuzzySearch parent={debugName} inputRef={inputRef} />
                <Grid
                    size={{
                        xs: 12,
                        sm: 12
                    }}><Typography variant="body1" align="center">OR SELECT MANUALLY BELOW</Typography></Grid>
                <EliminationSearch parent={debugName} inputRef={inputRef} />
            </Grid>
        </Paper>)
    );
}

export default React.memo(JobSearch)